import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs-compat';
import { map, startWith } from 'rxjs/operators';
import { PatientConfirmDialogComponent } from '../ChildControls/patient-confirm-dialog/patient-confirm-dialog.component';
import { IAlerts } from '../models/IAlerts';
import { IAttributes } from '../models/IAttributes';
import { ICityDetails } from '../models/ICityDetails';
import { ILocationDetails } from '../models/ILocationDetails';
import { IOrderNote } from '../models/IOrderNote';
import { ContactInfo, IPersonalInfo, SearchInfo } from '../models/IPersonalInfo';
import { PatientSearchService } from '../patient-search/patient-search.service';
import { ConfirmDialogModel, DeleteDocumentComponent } from '../PatientChart/Document/delete-document/delete-document.component';
import { PersonalInfoService } from '../Services/Demographics/personal-info.service';
import { SchedularServiceService } from '../Services/Schedular/schedular-service.service';
import { CommonComponents } from '../Sharedservice/CommonComponents';
import { SharedService } from '../Sharedservice/SharedService';

@Component({
  selector: 'app-search-patient-dmpopup',
  templateUrl: './search-patient-dmpopup.component.html',
  styleUrls: ['./search-patient-dmpopup.component.css']
})
export class SearchPatientDMPopupComponent implements OnInit {
  DMPatientSearchForm: FormGroup;
  DMPatientCreateForm: FormGroup;
  personalInfos: IPersonalInfo[];
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['dPatId', 'Name', 'DOB', 'SSN', 'phone', 'zip', 'location', 'Action'];
  results: any;
  searchTerm$ = new Subject<string>();
  orderNote: IOrderNote;
  selectedRowIndex: number = -1;
  searchResultStatus: boolean;
  public lstalerts: IAlerts[];
  public PopUpAlerts: IAlerts[] = [];
  public birthdate: Date;
  disableAction: false;
  isdisablebtns: boolean = false;
  IsPatSearch: boolean = true;
  patIdFilter = new FormControl('');
  patNameFilter = new FormControl('');
  patDOBFilter = new FormControl('');
  patSSNFilter = new FormControl('');
  patphoneFilter = new FormControl('');
  patZipFilter = new FormControl('');
  dpatIdFilter = new FormControl('');
  locationFilter = new FormControl('');
  filterValues = { patientId: '', name: '', dob: '', ssn: '', phone: '', postalCode: '', dpatId: '', locationName: '' };
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('saveUserId', { static: false }) saveUserId: ElementRef;

  @HostListener("document:click", ['$event'])
  documentClickListner(event) {
    if (event.target.id == "locationsfocus" || event.currentTarget.activeElement.parentElement.id == "userselectLoc") {
      this.SelectedDropDownListId = true
    } else if (event.target.id == "NewPatientlocationsfocus" || event.currentTarget.activeElement.parentElement.id == "NewPatientuserselectLoc") {
      this.SelectedDropDownListId = true
    }
    else {
      event.stopPropagation();
      this.SelectedDropDownListId = false
    }
  }
  constructor(public dialogRef: MatDialogRef<SearchPatientDMPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder
    , private patservice: PatientSearchService
    , public datepipe: DatePipe
    , public dialog: MatDialog
    , private toastr: ToastrService
    , private spinner: NgxSpinnerService
    , private schedulerservice: SchedularServiceService
    , private sharedService: SharedService
    , private personalService: PersonalInfoService
  ) {
    this.spinner.hide();
    this.personalInfos = null;
    this.dataSource.data = [];
    this.createPersonalObj();
    this.getSystem();
    if (this.data != null) {
      if (this.data.action)
        this.disableAction = this.data.action;

    }
  }

  formErrors = {
    'locations': '',
  };
  validationMessages = {
    'locations': {
      'required': 'Location is required.',
    },
  };

  ngOnInit() {
    this.DMPatientSearchForm = this.fb.group({
      patientId: [''],
      lastName: [''],
      firstName: [''],
      DOB: [''],
      SSN: [''],
      postalCode: [''],
      phone: [''],
      isActive: [''],
      dPatId: [''],
      locations: ['', Validators.required],
      IsLocationCheck: [''],
    });

    this.DMPatientCreateForm = this.fb.group({
      lastName: [''],
      firstName: [''],
      middleName: [''],
      DOB: [''],
      gender: [''],
      locationId: [''],
      address1: [''],
      postalCode: [''],
      city: [''],
      state: [''],
      homePhone: [''],
    });
    if (this.data) {
      if (this.data.patient) {
        this.DMPatientSearchForm.patchValue({
          lastName: this.data.patient.lastName,
          firstName: this.data.patient.firstName,
          DOB: this.datepipe.transform(this.data.patient.dob, 'yyyy-MM-dd') // this.transform(this.data.patient.dob)
        })
        this.DMPatientCreateForm.patchValue({
          lastName: this.data.patient.lastName,
          firstName: this.data.patient.firstName,
          DOB: this.datepipe.transform(this.data.patient.dob, 'yyyy-MM-dd')// this.transform(this.data.patient.dob)
        })
      }
    }
    this.getLocations();
    this.personalDropDownsBinding();
    this.patIdFilter.valueChanges
      .subscribe(
        patientId => {
          this.filterValues.patientId = patientId;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patNameFilter.valueChanges
      .subscribe(
        name => {
          this.filterValues.name = name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patDOBFilter.valueChanges
      .subscribe(
        dob => {
          this.filterValues.dob = dob;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patSSNFilter.valueChanges
      .subscribe(
        ssn => {
          this.filterValues.ssn = ssn;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patphoneFilter.valueChanges
      .subscribe(
        phone => {
          this.filterValues.phone = phone;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patZipFilter.valueChanges
      .subscribe(
        postalCode => {
          this.filterValues.postalCode = postalCode;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.locationFilter.valueChanges
      .subscribe(
        locationName => {
          this.filterValues.locationName = locationName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.dpatIdFilter.valueChanges
      .subscribe(
        dPatId => {
          this.filterValues.patientId = dPatId;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  getSystem() {
    if (sessionStorage.getItem("patientName") != null || sessionStorage.getItem("patientName") != undefined) {
      CommonComponents.patientName = sessionStorage.getItem("patientName");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
  }
  public onload() {
    this.clearSearch();
  }

  fnSetLocationFromParent() {
    this.clearSearch();
    this.dataSource.data = [];
    this.getLocations()
  }

  //searchquery: string;
  searchquery: SearchInfo;
  contactInformation: ContactInfo[];
  ssNumber: string = ''
  phone: string = '';
  postalcodeFormat: string = '';
  onSubmit() {
    var checkInputControlInfo = this.checkInputControldata();
    if (checkInputControlInfo == false) {
      return false
    } else {
    }
    this.clearfiltervalues();
    this.createsearchquery();

    setTimeout(() => {
      this.searchEntryData();
    }, 100);
  }

  searchEntryData() {
    if (this.searchquery) {
      this.patservice.searchEntries(this.searchquery)
        .subscribe((results: IPersonalInfo[]) => {
          this.personalInfos = results;
          if (this.personalInfos.length != 0) {
            this.personalInfos.forEach(i => {
              //******* SSN Number */
              if (i.ssn == undefined || i.ssn == null || i.ssn == '') {
                this.ssNumber = '';
              } else {
                this.ssNumber = i.ssn;
                var ssn = this.ssNumber.substring(0, 3);
                var ssn1 = this.ssNumber.substring(3, 5)
                this.ssNumber = ssn + '-' + ssn1 + '-' + this.ssNumber.substring(5, 9)
              }
              //******* Home Phone / Cell Phone */
              if (i.phone == undefined || i.phone == null || i.phone == '') {
                this.phone = '';
              } else {
                var phoneNumbers = i.phone;
                var numberSplit = phoneNumbers.split(',');
                var cellPhone = numberSplit[0];
                var homePhone = numberSplit[1];

                if (homePhone == undefined || homePhone == null || homePhone == '') {
                  var cellPhoneFormat = cellPhone.substring(0, 3) + '-' + cellPhone.substring(3, 6) + '-' + cellPhone.substring(6, 10);
                  if (cellPhoneFormat == '--') {
                    this.phone = '';
                  } else {
                    this.phone = cellPhoneFormat;
                  }
                } else {
                  var cellPhoneFormat = cellPhone.substring(0, 3) + '-' + cellPhone.substring(3, 6) + '-' + cellPhone.substring(6, 10);
                  var homePhoneFormat = homePhone.substring(0, 3) + '-' + homePhone.substring(3, 6) + '-' + homePhone.substring(6, 10);
                  this.phone = cellPhoneFormat + ',' + homePhoneFormat;
                }
              }
              //*******Postal Code  */
              if (i.postalCode != '' || i.postalCode != undefined || i.postalCode != null) {
                if (i.postalCode.length == 9) {
                  var postalcode = i.postalCode;
                  this.postalcodeFormat = postalcode.substring(0, 5) + '-' + postalcode.substring(5, 9)
                } else {
                  if (i.postalCode.length == 6 || i.postalCode.length == 7
                    || i.postalCode.length == 8) {
                    var postalcode = i.postalCode;
                    this.postalcodeFormat = postalcode.substring(0, 5) + '-' + postalcode.substring(5, 9)
                  } else {
                    this.postalcodeFormat = i.postalCode;
                  }
                }
              }
              i.ssn = this.ssNumber;
              i.phone = this.phone;
              i.postalCode = this.postalcodeFormat;
            })
          } else {
            this.ssNumber = '';
            this.phone = '';
            this.postalcodeFormat = '';
          }

          if (this.personalInfos.length == 0)
            this.searchResultStatus = true;
          else
            this.searchResultStatus = false;

          this.dataSource.data = this.personalInfos;
          this.dataSource.filterPredicate = this.createFilter();
          this.dataSource.paginator = this.paginator;
        }, (err: any) => {
          console.log(err)
          this.spinner.hide();
        });
    }
  }

  checkInputfields: boolean = false;
  checkInputControldata() {
    if (this.DMPatientSearchForm.value.patientId == "" && this.DMPatientSearchForm.value.lastName == "" && this.DMPatientSearchForm.value.firstName == ""
      && this.DMPatientSearchForm.value.DOB == "" && this.DMPatientSearchForm.value.SSN == "" && this.DMPatientSearchForm.value.locations == ""
      && this.DMPatientSearchForm.value.phone == "" && this.DMPatientSearchForm.value.postalCode == "") {
      this.toastr.error('Please select atleast one field.')
      this.dataSource.data = [];
      this.checkInputfields = false;
    } else {
      this.checkInputfields = true;
    }
    return this.checkInputfields;
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.dPatId.toString().indexOf(searchTerms.patientId) !== -1
        && data.name.toString().toLowerCase().indexOf(searchTerms.name) !== -1
        && data.dob.toString().toLowerCase().indexOf(searchTerms.dob) !== -1
        && data.ssn.toString().toLowerCase().indexOf(searchTerms.ssn) !== -1
        && data.phone.toString().toLowerCase().indexOf(searchTerms.phone) !== -1
        && data.postalCode.toString().toLowerCase().indexOf(searchTerms.postalCode) !== -1
        && (data.locationName === null ? "" : data.locationName).toString().toLowerCase().indexOf(searchTerms.locationName.toLowerCase()) !== -1
        ;
    }
    return filterFunction;
  }

  createsearchquery() {
    if (this.DMPatientSearchForm.value != null) {
      this.searchquery = {
        patientId: null,
        lastName: '',
        firstName: '',
        DOB: '',
        SSN: '',
        ZIP: '',
        phone: '',
        userid: '',
        isActive: null,
        facilityId: null,
        locationId: '',
        //Stdate: null,
        //Eddate: null
      }
      if (this.DMPatientSearchForm.value.patientId != 'undefined' && this.DMPatientSearchForm.value.patientId)
        this.searchquery.patientId = this.DMPatientSearchForm.value.patientId;
      if (this.DMPatientSearchForm.value.lastName != 'undefined' && this.DMPatientSearchForm.value.lastName)
        this.searchquery.lastName = this.DMPatientSearchForm.value.lastName;
      else {
        this.searchquery.lastName = null;
      }
      if (this.DMPatientSearchForm.value.firstName != 'undefined' && this.DMPatientSearchForm.value.firstName)
        this.searchquery.firstName = this.DMPatientSearchForm.value.firstName;
      else {
        this.searchquery.firstName = null;
      }
      if (this.DMPatientSearchForm.value.DOB != 'undefined' && this.DMPatientSearchForm.value.DOB) {
        var selecteddate = this.datepipe.transform(this.DMPatientSearchForm.value.DOB, 'yyyy-MM-dd');
        this.searchquery.DOB = selecteddate;
      } else {
        this.searchquery.DOB = null;
      }
      if (this.DMPatientSearchForm.value.SSN != 'undefined' && this.DMPatientSearchForm.value.SSN)
        this.searchquery.SSN = this.DMPatientSearchForm.value.SSN;
      else {
        this.searchquery.SSN = null;
      }
      if (this.DMPatientSearchForm.value.phone != 'undefined' && this.DMPatientSearchForm.value.phone)
        this.searchquery.phone = this.DMPatientSearchForm.value.phone;
      else {
        this.searchquery.phone = null;
      }
      if (this.DMPatientSearchForm.value.postalCode != 'undefined' && this.DMPatientSearchForm.value.postalCode)
        this.searchquery.ZIP = this.DMPatientSearchForm.value.postalCode;
      else {
        this.searchquery.ZIP = null;
      }
      // if (typeof this.PersonalSearchForm.value.isActive != 'undefined' && this.PersonalSearchForm.value.isActive)
      //   this.searchquery = this.searchquery + "isActive=false" + "&&";
      if (this.DMPatientSearchForm.value.isActive)
        this.searchquery.isActive = this.DMPatientSearchForm.value.isActive;

      if (typeof this.locationID[0].locationName != 'undefined' && this.locationID[0].locationName != "") {
        if (this.selectedLocationIds.length == 0)
          this.selectedLocationIds[0] = '0';
        this.searchquery.locationId = this.selectedLocationIds.toString();
      }
      else if (this.locationID[0].locationName == "")
        this.searchquery.locationId = '0';
      // else if (this.searchquery != '')
      //   this.searchquery = this.searchquery + "isActive=true" + "&&";
      if (this.searchquery != null && this.searchquery != undefined)
        this.searchquery.facilityId = Number(sessionStorage.getItem('FacilityId'));
      //this.searchquery = this.searchquery.substring(0, this.searchquery.length - 2);
    }
  }
  /*
    createsearchquery() {
      if (this.DMPatientSearchForm.value != null) {
        this.searchquery = '';
        if (typeof this.DMPatientSearchForm.value.patientId != 'undefined' && this.DMPatientSearchForm.value.patientId)
          this.searchquery = this.searchquery + "patientId=" + this.DMPatientSearchForm.value.patientId + "&&";
        if (typeof this.DMPatientSearchForm.value.lastName != 'undefined' && this.DMPatientSearchForm.value.lastName)
          this.searchquery = this.searchquery + "lastName=" + this.DMPatientSearchForm.value.lastName + "&&";
        if (typeof this.DMPatientSearchForm.value.firstName != 'undefined' && this.DMPatientSearchForm.value.firstName)
          this.searchquery = this.searchquery + "firstName=" + this.DMPatientSearchForm.value.firstName + "&&";
        if (typeof this.DMPatientSearchForm.value.DOB != 'undefined' && this.DMPatientSearchForm.value.DOB) {
          var selecteddate = this.datepipe.transform(this.DMPatientSearchForm.value.DOB, 'yyyy-MM-dd');
          this.searchquery = this.searchquery + "DOB=" + selecteddate + "&&";
        }
        if (typeof this.DMPatientSearchForm.value.SSN != 'undefined' && this.DMPatientSearchForm.value.SSN)
          this.searchquery = this.searchquery + "SSN=" + this.DMPatientSearchForm.value.SSN + "&&";
        if (typeof this.DMPatientSearchForm.value.phone != 'undefined' && this.DMPatientSearchForm.value.phone)
          this.searchquery = this.searchquery + "phone=" + this.DMPatientSearchForm.value.phone + "&&";
        if (typeof this.DMPatientSearchForm.value.postalCode != 'undefined' && this.DMPatientSearchForm.value.postalCode)
          this.searchquery = this.searchquery + "ZIP=" + this.DMPatientSearchForm.value.postalCode + "&&";
        if (typeof this.DMPatientSearchForm.value.isActive != 'undefined' && this.DMPatientSearchForm.value.isActive)
          this.searchquery = this.searchquery + "isActive=false" + "&&";
  
        if (typeof this.locationID[0].locationName != 'undefined' && this.locationID[0].locationName != "") {
          if (this.selectedLocationIds.length == 0)
            this.selectedLocationIds[0] = '0';
          this.searchquery = this.searchquery + "locationId=" + this.selectedLocationIds + "&&";
        }
        else if (this.locationID[0].locationName == "")
          this.searchquery = this.searchquery + "locationId=" + '0' + "&&";
        else if (this.searchquery != '')
          this.searchquery = this.searchquery + "isActive=true" + "&&";
        if (this.searchquery != '')
          this.searchquery = this.searchquery + "facilityId=" + sessionStorage.getItem('FacilityId') + "&&";
        this.searchquery = this.searchquery.substring(0, this.searchquery.length - 2);
      }
    }
  */
  clearSearch() {
    try {
      this.searchResultStatus = false;
      if (this.DMPatientSearchForm != null) {
        if (this.DMPatientSearchForm.value) {
          this.DMPatientSearchForm.reset({
            'dPatId': '',
            'patientId': '',
            'lastName': '',
            'firstName': '',
            'DOB': '',
            'SSN': '',
            'phone': '',
            'postalCode': '',
            'isActive': '',
          });
        }
        this.selectedLocationIds = [];
        if (this.lstLocations) {
          for (let index = 0; index < this.lstLocations.length; index++) {
            this.lstLocations[index].selected = false;
          }
        }
      }
      if (this.personalInfos != undefined) {
        if (this.personalInfos.length > 0) {
          this.personalInfos = [];
          this.dataSource.data = [];
        }
      }
      this.clearfiltervalues();
    }
    catch (ex) {
      console.log(ex);
    }
  }

  clearfiltervalues() {
    this.patIdFilter.setValue("");
    this.patNameFilter.setValue("");
    this.patDOBFilter.setValue("");
    this.patSSNFilter.setValue("");
    this.patphoneFilter.setValue("");
    this.patZipFilter.setValue("");
    this.dpatIdFilter.setValue("");
    this.locationFilter.setValue("");
  }

  close() {
    this.clearSearch();
    this.dialogRef.close();
  }

  oncellclick(element) {
    this.dialogRef.close(element);
  }

  public visitDate: Date;
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  alphanumericonly(event): boolean {
    var regex = new RegExp("^[a-zA-Z0-9/b]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }

  validateDate(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 47) {
      event.preventDefault();
      return false;
    }
    return true;
  }
  public todayDate = new Date();

  //********* Newly Added Multiselect dropdown */
  UsersFocus() {
    this.SelectedDropDownListId = true;
  }
  focusOutFunctionLocation(evn) {
    if (evn.keyCode === 9) {
      setTimeout(() => {
        this.saveUserId.nativeElement.focus();
      }, 100);

      this.SelectedDropDownListId = false;
    } else if (evn.keyCode === 40 && evn.target.id == "locationsfocus") {
      $('#locationlistoption0').focus();
    }
  }

  UsersFocus1() {
    this.SelectedDropDownListId = true;
  }

  focusOutFunctionLocation1(evn) {
    if (evn.keyCode === 9) {
      $('#locationsfocushide').hide()
      this.SelectedDropDownListId = false;
    } else if (evn.keyCode === 40 && evn.target.id == "NewPatientlocationsfocus") {
      $('#locationlistoption10').focus();
    }
  }

  patDemoLocIds: string;
  NPselectedLocationId: string;
  patLocId: number;
  patmultilocIds: any;
  LocationsSelectionChanged1(locationRef1) {

    this.patDemoLocIds = '';
    this.NPselectedLocationId = '';
    this.patLocId = null;
    let locselected = '';
    let multilocation = '';
    this.patmultilocIds = [];
    this.locationsList = locationRef1.selectedOptions.selected.map(item => item.value);
    for (let index = 0; index < this.locationsList.length; index++) {
      if (index == 0) {
        this.patLocId = this.locationsList[index].locationId;
      }
      this.patDemoLocIds += this.locationsList[index].locationId + ',';
      this.patmultilocIds.push(this.locationsList[index].locationId);
    }

    this.locationsList.forEach(x => {
      var i = 0;
      this.lstLocations.forEach(y => {
        if (y.locationId == x.locationId) {
          locselected += this.lstLocations[i].locationName + ', ';
        }
        i = i + 1;
      });
    });

    if (this.locationsList.length != 0) {
      this.NPselectedLocationId = this.patDemoLocIds.substring(0, this.patDemoLocIds.length - 1);
      multilocation = locselected.substring(0, locselected.length - 2);
    }

    this.patmultilocIds = this.NPselectedLocationId.split(",")
    this.lstLocations.filter(x => x.selected = false)
    this.lstLocations.filter(x => this.patmultilocIds.includes(x.locationId.toString())).map(y => y.selected = true)

    this.DMPatientCreateForm.patchValue({
      locationId: multilocation
    });
  }

  SelectedDropDownListId: boolean = false;
  arryOfselectedLocationsIdsUpdate: string[] = [];
  locationNameUpdate: string;
  locationsList: ILocationDetails[];
  selectedLocationIds: string[] = [];
  LocationSelectionChanged(LocationupdateRef) {
    this.locationsList = LocationupdateRef.selectedOptions.selected.map(item => item.value);
    this.locationNameUpdate = '';
    let selectedLocationsIdsUpdate = [];
    this.selectedLocationIds = [];
    this.arryOfselectedLocationsIdsUpdate = [];
    for (let index = 0; index < this.locationsList.length; index++) {
      this.locationNameUpdate += this.locationsList[index].locationName + ', ';
      selectedLocationsIdsUpdate.push(this.locationsList[index].locationId);
      this.selectedLocationIds.push(this.locationsList[index].locationId.toString())
      this.arryOfselectedLocationsIdsUpdate.push(this.locationsList[index].locationId.toString())
    }

    if (this.locationsList.length > 0 && this.locationsList != null)
      this.isdisablebtns = false;
    else
      this.isdisablebtns = true;

    this.lstLocations.filter(x => x.selected = false) // default set false
    this.lstLocations.filter(x => selectedLocationsIdsUpdate.includes(x.locationId)).map(y => y.selected = true)

    this.DMPatientSearchForm.patchValue({
      locations: this.locationNameUpdate.substring(0, this.locationNameUpdate.length - 2)
    })

    this.checkDefaultLocations();

  }
  checkDefaultLocations() {
    if (this.selectedList.length > 0 && this.selectedList != undefined) {
      var selectProvlst = this.selectedList.filter(x => x.selected == true);
      if (selectProvlst.length === this.lstLocations.length) {
        this.DMPatientSearchForm.patchValue({
          IsLocationCheck: true
        });
      } else {
        this.DMPatientSearchForm.patchValue({
          IsLocationCheck: false
        });
      }
    } else {
      this.DMPatientSearchForm.patchValue({
        IsLocationCheck: false
      });
    }

    if (selectProvlst.length > 0 || this.locationsList.length > 0)
      this.isdisablebtns = false;
    else
      this.isdisablebtns = true;
  }

  public lstLocations: ILocationDetails[];
  locationID: any;
  getLocationId: any;
  name: any;
  getLocations() {
    if ((sessionStorage.getItem("userId") || sessionStorage.getItem("FacilityId")))
      this.schedulerservice.getLocations().subscribe(data => {
        this.spinner.hide();
        this.lstLocations = data;
        this.selectedLocationIds = [];
        this.getLocationId = sessionStorage.getItem("LocationId"); //this.patservice.urlValue;//
        if (this.getLocationId == "0") {
          this.locationID = this.lstLocations[0].locationName.toString();
          this.isdisablebtns = true
        } else {
          this.locationID = this.lstLocations.filter(x => x.locationId === Number(this.getLocationId))
          this.selectedLocationIds.push(this.locationID[0].locationId);
          this.isdisablebtns = false;
        }

        this.lstLocations.filter(x => x.selected = false) // default set false
        this.lstLocations.filter(x => x.locationId == this.locationID[0].locationId).map(y => y.selected = true);

        this.DMPatientSearchForm.patchValue({
          locations: this.locationID[0].locationName,
        });
      });

  }

  selectedList: ILocationDetails[];
  selected: string = "";
  selectedName: string;
  checkAllLocations(event) {
    let ischk: any
    if (event.keyCode == 32) {
      ischk = !event.target.checked
    } else {
      ischk = event.target.checked
    }
    if (ischk == true) {
      this.isdisablebtns = false;
      this.selectedList = [];
      this.selectedLocationIds = [];
      this.selected = '';
      this.locationNameUpdate = '';
      this.lstLocations = this.lstLocations.filter(x => x.selected = true)
      this.selectedList = this.lstLocations;

      for (let index = 0; index < this.selectedList.length; index++) {
        this.selectedList[index].selected = true;
        this.selected += this.selectedList[index].locationId + ',';
        this.selectedLocationIds.push(this.selectedList[index].locationId.toString())

        this.locationNameUpdate += this.selectedList[index].locationName + ', ';
      }
      if (this.selectedList.length != 0) {
        this.locationNameUpdate = this.locationNameUpdate.substring(0, this.locationNameUpdate.length - 2);
      }
      this.DMPatientSearchForm.patchValue({
        locations: this.locationNameUpdate
      });
    } else {
      this.isdisablebtns = true;
      for (let index = 0; index < this.selectedList.length; index++) {
        this.selectedList[index].selected = false;
      }
      this.selectedLocationIds = [];
      this.selected = '';
      this.selectedName = '';
      this.DMPatientSearchForm.patchValue({
        locations: this.selectedName
      });
    }
  }
  genderOptions: Observable<IAttributes[]>;
  cmbnotes: string = '';
  public genderId: string;
  public selectedLocationId: string;
  onSelectionChanged(event$, type: string) {
    setTimeout(() => {
      $(event$.target).prev().trigger('focus');
    }, 100);

    this.cmbnotes = event$;
    if (type === 'Gender') {
      let genderlist = this.lstGender.filter(x => x.attributeName === this.cmbnotes);
      if (genderlist.length != 0) {
        this.genderId = genderlist[0].attributeId;
      } else {
        this.genderId = "";
      }
    } else if (type === 'Location') {
      let locationList = this.lstLocations.filter(x => x.locationName === this.cmbnotes);
      if (locationList.length != 0) {
        this.selectedLocationId = locationList[0].locationId.toString();
      } else {
        this.selectedLocationId = "";
      }
    }
  }
  public lstattrbutes: IAttributes[];
  public lstGender: IAttributes[];
  personalDropDownsBinding() {
    this.sharedService.getAttributes().subscribe(data => {
      this.lstattrbutes = data;
      this.lstGender = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '11');
      this.genderFilter();
    });
  }

  genderFilter() {
    this.genderOptions = this.DMPatientCreateForm.get('gender')!.valueChanges.pipe(
      startWith(""),
      map(value => this.genFilter(value))
    );
  }

  private genFilter(name: string): IAttributes[] {
    const filterValue = name.toString().toLowerCase();
    return this.lstGender.filter(option => option.attributeName.toLowerCase().indexOf(filterValue) === 0);
  }

  requiredfieldsfocus(frmcntrlname) {
    this.DMPatientCreateForm.controls[frmcntrlname].setValidators(null);
    this.DMPatientCreateForm.controls[frmcntrlname].setErrors(null);
  }
  requfieldsfocusout(frmcntrlname) {
    this.DMPatientCreateForm.controls[frmcntrlname].setValidators([Validators.required]);
    this.DMPatientCreateForm.controls[frmcntrlname].updateValueAndValidity();
  }

  avoidspaceatfirst(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }

  public lstCityInfo: ICityDetails[];
  onKeyPress(event: any) {
    const keyCode = event.keyCode;
    const excludedKeys = [9, 16];
    if (event.keyCode === 8) {
      this.lstCityInfo = [];
      this.cityTypeFilter();
    }
    if (event.keyCode == 40 || event.keyCode == 13) {
    } else {
      if (!(excludedKeys.includes(keyCode))) {
        const zip = event.target.value;
        if (zip.length == 5) {
          this.getZipCodeInfo(zip);
        }
        else {
          this.lstCityInfo = [];
          this.cityTypeFilter();
          this.DMPatientCreateForm.patchValue({
            city: "",
            state: ""
          });
        }
      }
    }
  }

  cityTypeOptions: Observable<ICityDetails[]>;
  cityTypeFilter() {
    this.cityTypeOptions = this.DMPatientCreateForm.get('postalCode')!.valueChanges
      .pipe(
        startWith(''),
        map(value => this.postalCode(value))
      );
  }
  private postalCode(name: string): ICityDetails[] {
    const filterValue = name.toString().toLowerCase();
    return this.lstCityInfo.filter(option => option.cityName.toLowerCase().indexOf(filterValue) === 0);
  }
  zipCodevalue: number = 0;
  cityInfoDummyLst: ICityDetails[] = [];
  getZipCodeInfo(id: number) {
    if (id != null) {
      this.zipCodevalue = id;
      this.sharedService.getZipCodeDetailsAutoComplete(id)
        .subscribe(
          (city: ICityDetails[]) => {
            this.lstCityInfo = city;
            this.cityInfoDummyLst = city;
            if (this.lstCityInfo.length == 0) {
              this.toastr.error('Invalid Zip code')
              this.DMPatientCreateForm.patchValue({
                postalCode: '',
              })
            }

            if (this.lstCityInfo.length > 1) {
              this.cityTypeFilter()
            } else {
              this.lstCityInfo = [];
              this.cityTypeFilter();
              this.DMPatientCreateForm.patchValue({
                city: city[0].cityName,
                state: city[0].stateName
              });
            }
          },
          (err: any) => console.log(err)
        );
    }
    else {
      this.sharedService.getZipCodeDetailsAutoComplete(id)
        .subscribe((city: ICityDetails[]) => { },
          (err: any) => console.log(err)
        );
    }
  }

  onTabclick1() {
    this.sharedService.getZipCodeDetailsAutoComplete(this.zipCodevalue)
      .subscribe(
        (city: ICityDetails[]) => {
          this.lstCityInfo = city;
          if (this.lstCityInfo.length == 0) {
            this.lstCityInfo = [];
            this.cityTypeFilter();
            this.DMPatientCreateForm.patchValue({
              city: city[0].cityName,
              state: city[0].stateName
            });
          } else {
            if (this.DMPatientCreateForm.value.city === "" && this.DMPatientCreateForm.value.postalCode != "") {
              setTimeout(() => {
                var divctrl = document.getElementsByName("zipCode");
                divctrl[0].focus();
              }, 100);
            }
          }
        },
        (err: any) => console.log(err)
      );
  }

  focusOutZipCode() {
    if (this.DMPatientCreateForm.value.postalCode.length != 5) {
      this.toastr.error('Invalid Zip Code')
      this.DMPatientCreateForm.patchValue({
        postalCode: ''
      })
    }
  }
  chkCityName: string = "";
  onKeyEnterevent(event) {
    var chkLst: ICityDetails[] = this.cityInfoDummyLst.filter(x => x.cityName.toString() === event.target.value.toString())
    if (chkLst.length != 0 && chkLst != undefined) {
      this.chkCityName = chkLst[0].cityName;
      this.DMPatientCreateForm.patchValue({
        city: chkLst[0].cityName,
        state: chkLst[0].stateName,
        postalCode: this.zipCodevalue
      });
    }
  }

  onClickZipCode(event) {
    this.DMPatientCreateForm.patchValue({
      city: event.cityName,
      state: event.stateName,
      postalCode: this.zipCodevalue
    });
  }

  onNewPatient() {
    this.IsPatSearch = false;
    this.patDemoLocIds = '';
    this.NPselectedLocationId = '';
    this.patLocId = null;
    let locselected = '';
    let multilocation = '';
    this.patmultilocIds = [];
    this.patLocId = Number(sessionStorage.getItem("LocationId"));
    multilocation = this.lstLocations.filter(x => x.locationId === Number(this.patLocId))[0].locationName
    this.patDemoLocIds = this.patLocId.toString();
    this.patmultilocIds.push(this.patLocId.toString());
    this.NPselectedLocationId = this.patDemoLocIds;
    this.patmultilocIds = this.NPselectedLocationId.split(",")
    this.lstLocations.filter(x => x.selected = false)
    this.lstLocations.filter(x => this.patmultilocIds.includes(x.locationId.toString())).map(y => y.selected = true)

    this.DMPatientCreateForm.patchValue({
      locationId: multilocation
    });
  }

  onPatientCreation() {
    this.mapFormValuesToPersonalModel();
    this.checkPatientDetailsInsert();
  }
  personalInfo: IPersonalInfo;
  createPersonalObj() {
    this.personalInfo = {
      patientId: null,
      lastName: '',
      salutation: '',
      motherMaidenFN: '',
      race: '',
      accountNo: '',
      referralStatus: '',
      middleName: '',
      gender: '',
      genderIdentity: '',
      sexualOrientation: '',
      preferredContactMethod: '',
      patientStatus: '',
      isActive: true,
      patPhoto: null,
      motherMaidenLN: '',
      ethniCity: '',
      accountType: '',
      firstName: '',
      dob: null,
      ssn: '',
      languages: '',
      accountStatus: '',
      suffix: '',
      maritalStatus: '',
      patientStatusDateTime: null,
      notes: '',
      employmentStatus: null,
      modifiedUser: '',
      createdBy: '',
      createdOn: null,
      modifiedBy: '',
      modifiedOn: null,
      clientId: null,
      patientPic: null,
      drivingLicenceNo: '',
      secondaryEmail: '',
      practiceProvider: '',
      locationId: null,
      locationName: '',
      dPatId: null,
      genderName: '',
      phone: '',
      postalCode: '',
      patientLocationIds: '',
      linkId: '',
      requestType: '',
      TranslatorRequired: false,
      currentAddressDetails: {
        addressId: null,
        address1: '',
        address2: '',
        address3: '',
        postalCode: '',
        postalExCode: '',
        emailId: '',
        homePhone: '',
        city: '',
        cellPhone: '',
        state: '',
        stateCode: '',
        workPhone: '',
        fax: '',
        createdBy: '',
        createdOn: null,
        secondaryaddress1: '',
        secondaryaddress2: '',
        secondaryaddress3: '',
        secondarystate: '',
        secondarystateCode: '',
        secondarycity: '',
        secondarypostalCode: '',
        secondarypostalExCode: '',
        MailingAddress: '',
        phonenumber4: '',
        phonenumber5: ''
      },
      IsOldPatient:false,
      facilityId: null
    };
  }

  mapFormValuesToPersonalModel() {
    this.schedulerservice.getservercurrentdate().subscribe(async resulttt => {
      await resulttt;
      var addresscreatedDate = moment(resulttt).toDate();
      this.personalInfo.currentAddressDetails.createdOn = addresscreatedDate != null ? moment(addresscreatedDate).toDate() : null;
    });
    this.personalInfo.lastName = this.DMPatientCreateForm.value.lastName;
    this.personalInfo.firstName = this.DMPatientCreateForm.value.firstName;
    this.personalInfo.middleName = this.DMPatientCreateForm.value.middleName;
    this.personalInfo.gender = this.genderId;
    var dobDate = moment(this.DMPatientCreateForm.value.DOB).toDate();
    this.personalInfo.dob = dobDate != null ? this.transform(moment(dobDate).toDate().toString()) : null;
    this.personalInfo.locationId = this.patLocId;
    this.personalInfo.patientLocationIds = this.NPselectedLocationId;
    this.personalInfo.currentAddressDetails.address1 = this.DMPatientCreateForm.value.address1;
    this.personalInfo.currentAddressDetails.city = this.DMPatientCreateForm.value.city;
    this.personalInfo.currentAddressDetails.state = this.DMPatientCreateForm.value.state;
    this.personalInfo.currentAddressDetails.postalCode = this.DMPatientCreateForm.value.postalCode;
    this.personalInfo.currentAddressDetails.homePhone = this.DMPatientCreateForm.value.homePhone;
    this.personalInfo.modifiedUser = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.personalInfo.isActive = true;
    this.personalInfo.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.personalInfo.clientId = Number(sessionStorage.getItem('FacilityId'));
  }

  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(moment(value).toDate(), 'MM/dd/yyyy');
    }
    return value;
  }

  Clearformfields() {
    this.DMPatientCreateForm.patchValue({
      lastName: '',
      gender: '',
      firstName: '',
      DOB: '',
      address1: '',
      postalCode: '',
      homePhone: '',
      city: '',
      state: '',
      locationId: '',
    });
    this.NPselectedLocationId = '';
    if (this.lstLocations) {
      for (let index = 0; index < this.lstLocations.length; index++) {
        this.lstLocations[index].selected = false;
      }
    }
  }

  public result: any;
  checkPatientDetailsInsert() {
    if (this.DMPatientCreateForm.value.lastName == '') {
      this.toastr.warning("Please enter Last name.");
      return;
    }
    if (this.DMPatientCreateForm.value.firstName == '') {
      this.toastr.warning("Please enter First name.");
      return;
    }
    if (this.DMPatientCreateForm.value.DOB == '') {
      this.toastr.warning("Please enter DOB.");
      return;
    }

    var LName = this.DMPatientCreateForm.value.lastName;
    var FName = this.DMPatientCreateForm.value.firstName;
    var MName = this.DMPatientCreateForm.value.middleName;
    var Dob: any = this.datepipe.transform(this.DMPatientCreateForm.value.DOB, 'MM/dd/yyyy');
    this.personalService.getPatientDetailsCount(LName, FName, MName, Dob).subscribe(
      results => {
        this.result = results;
        if (this.result == 0) {
          const message = "Are you sure to save the details? ";
          const dialogData = new ConfirmDialogModel('Confirm Action', message);
          const dialogRef = this.dialog.open(DeleteDocumentComponent, {
            maxWidth: '800px',
            width: '300px',
            height: '120px',
            data: dialogData
          });
          dialogRef.afterClosed().subscribe(dialogResult => {
            this.result = dialogResult;
            if (this.result) {
              this.savePatientInfo();
            }
          });
        } else {
          const message = "There is a patient profile already created with the same <b><u>Last Name, First Name, & DOB.</u></b><br><br> Do you still wish to continue and generate a new Patient Profile with the same Last Name, First Name, & DOB?";
          const dialogData = new ConfirmDialogModel('Confirm Action', message);
          const dialogRef = this.dialog.open(PatientConfirmDialogComponent, {
            maxWidth: '400px',
            width: '290px',
            height: '390px',
            data: dialogData
          });

          dialogRef.afterClosed().subscribe(dialogResult => {
            this.result = dialogResult;
            if (this.result) {
              this.savePatientInfo();
            }
          });
        }
      });
  }
  public patId: number;
  savePatientInfo() {
    this.personalService.addDMPersonalInfo(this.personalInfo).subscribe(
      results => {
        this.result = results;
        this.result = this.result.split(":", 2);
        this.patId = this.result[1];
        this.toastr.success(this.result[0]);
        this.personalInfo.patientId = this.patId;
        this.dialogRef.close(this.personalInfo);
      });
  }

}



